






















import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  errors: string[];
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      errors: [],
    });

    /************************************************************
     * テンプレートダウンロード
     ************************************************************/

    const downloadTemplate = async (): Promise<void> => {
      window.location.href = `/api/teacher/qr_base_sheet_upload/download_template`;
    };
    
    /************************************************************
     * エクセルアップロード
     ************************************************************/

    const upload = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("ファイルをアップロードします。\nよろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");

      await http.post(`/api/teacher/qr_base_sheet_upload/upload`, fd).then(response => {

        alert("アップロードが完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    return {
      ...toRefs(state),
      downloadTemplate,
      upload,
    };
  }
})
